import axios from "axios";

export const INVOICES_URL = `${process.env.REACT_APP_API_URL}/invoices`;

// READ
export function FindInvoices(queryParams) {
  return axios.get(INVOICES_URL, {
    params: {
      pageSize: queryParams.pageSize,
      pageNumber: queryParams.pageNumber,
    },
  });
}

export function GetInvoiceById(invoiceId) {
  return axios.get(`${INVOICES_URL}/${invoiceId}`);
}

// Create
export function CreateInvoice(invoice) {
  return axios.post(INVOICES_URL, invoice);
}

// Update
export function UpdateInvoice({ id, description, branchId }) {
  return axios.put(INVOICES_URL, {
    id: id,
    description: description,
    branchId: branchId,
  });
}

// Delete
export function DeleteInvoice(invoiceId) {
  return axios.delete(`${INVOICES_URL}/${invoiceId}`);
}
